import FormData from "form-data"; // form-data v4.0.1
import Mailgun from "mailgun.js"; // mailgun.js v11.1.0

export async function mensagemNovoRelato({idRelato}) {
  const mailgun = new Mailgun(FormData);
  const mg = mailgun.client({
    username: "api",
    key: process.env.REACT_APP_API_EMAIL,
  });
  try {
    await mg.messages.create(process.env.REACT_APP_API_EMAIL_URL, {
      from: "Ouvidoria Mig-plus <sistema@ouvidoria-mig.vercel.app>",
      to: [process.env.REACT_APP_TO_EMAIL],
      subject: "Um novo relato foi registrado",
      html: "<h1>Olá,</h1><p>Um novo relato foi registrado pelo sistema </p>" + 
      "<p>Para acessar o relato, acesse o painel de administração</p>" +
      "<h2>Protocolo: " + idRelato + "</h2>" +
      "<a href='https://ouvidoria-mig.vercel.app/login'>Acessar painel</a>" +
      "<p>Atenciosamente,</p>" +
      "<p>Equipe Mig-plus</p>",
    });
  } catch (error) {
    console.log(error); //logs any error
  }
}

export async function mensagemAtualizaRelato({idRelato}) {
  const mailgun = new Mailgun(FormData);
  const mg = mailgun.client({
    username: "api",
    key: process.env.REACT_APP_API_EMAIL,
  });
  try {
    await mg.messages.create(process.env.REACT_APP_API_EMAIL_URL, {
      from: "Ouvidoria Mig-plus <sistema@ouvidoria-mig.vercel.app>",
      to: [process.env.REACT_APP_TO_EMAIL],
      subject: "Uma nova mensagem foi registrado",
      html: "<h1>Olá,</h1><p>Uma nova mensagem foi registrado pelo sistema </p>" + 
      "<p>Para acessar o relato, acesse o painel de administração</p>" +
      "<h2>Protocolo: " + idRelato + "</h2>" +
      "<a href='https://ouvidoria-mig.vercel.app/login'>Acessar painel</a>" +
      "<p>Atenciosamente,</p>" +
      "<p>Equipe Mig-plus</p>",
    });
  } catch (error) {
    console.log(error); //logs any error
  }
}

export async function mensagemNovoAcompanhamento({toEmail, mensagem}) {
  const mailgun = new Mailgun(FormData);
  const mg = mailgun.client({
    username: "api",
    key: process.env.REACT_APP_API_EMAIL,
  });
  try {
    await mg.messages.create(process.env.REACT_APP_API_EMAIL_URL, {
      from: "Ouvidoria Mig-plus <sistema@ouvidoria-mig.vercel.app>",
      to: [process.env.REACT_APP_TO_EMAIL, toEmail],
      subject: "Um novo acompanhamento foi registrado",
      html: "<h1>Olá,</h1>"+ 
      "<p>Um novo acompanhamento foi registrado pelo sistema</p>" + 
      "<h2>Mensagem:</h2>" +
      "<p>" + mensagem + "</p>" +
      "<p>Atenciosamente,</p>" +
      "<p>Equipe Mig-plus</p>",
    });
  } catch (error) {
    console.log(error); //logs any error
  }
}